import React from 'react';
import { SHOW_PLAN_INFO } from '../constants';

import Header from '../components/HeaderSection/Header';
import HeroSection from '../components/HeroSection/HeroFive';
import FeatureSection from '../components/Features/FeatureFive';
import ServiceSection from '../components/ServiceSection/ServiceFive';
import DiscoverSection from '../components/DiscoverSection/DiscoverFive';
import Work from '../components/WorkSection/Work';
import ReviewSection from '../components/ReviewSection/ReviewTwo';
import PricingSection from '../components/PricingSection/PricingOne';
import FaqSection from '../components/FaqSection/FaqOne';
import Download from '../components/DownloadSection/Download';
import Subscribe from '../components/SubscribeSection/Subscribe';
import ContactSection from '../components/ContactSection/Contact';
import FooterSection from '../components/FooterSection/Footer';

const ThemeFive = () => {
    return (
        <div className="inner-pages">
            {/*====== Scroll To Top Area Start ======*/}
            <div id="scrollUp" title="Scroll To Top">
                <i className="fas fa-arrow-up" />
            </div>
            {/*====== Scroll To Top Area End ======*/}
            <div className="main">
                <Header imageData={"/img/logo-white.png"} />
                <HeroSection />
                <FeatureSection />
                <DiscoverSection />
                <ServiceSection />
                <Work />
                {/* <ScreenshotSection /> */}
                <ReviewSection />
                {SHOW_PLAN_INFO && <PricingSection />}
                <FaqSection />
                {/* <Team /> */}
                <Download />
                <Subscribe />
                <ContactSection />
                <FooterSection />
            </div>
        </div>
    );
};

export default ThemeFive;